// Country code regex pattern for all countries (prioritizing longer codes first)
export const COUNTRY_CODE_REGEX =
  /^\+(1242|1246|1264|1268|1284|1340|1345|1441|1473|1649|1664|1670|1671|1684|1721|1758|1767|1784|1787|1809|1829|1849|1868|1869|1876|1939|212|213|216|218|220|221|222|223|224|225|226|227|228|229|230|231|232|233|234|235|236|237|238|239|240|241|242|243|244|245|246|247|248|249|250|251|252|253|254|255|256|257|258|260|261|262|263|264|265|266|267|268|269|290|291|297|298|299|350|351|352|353|354|355|356|357|358|359|370|371|372|373|374|375|376|377|378|380|381|382|383|385|386|387|389|420|421|423|500|501|502|503|504|505|506|507|508|509|590|591|592|593|594|595|596|597|598|599|670|672|673|674|675|676|677|678|679|680|681|682|683|684|685|686|687|688|689|690|691|692|850|852|853|855|856|880|886|960|961|962|963|964|965|966|967|968|970|971|972|973|974|975|976|977|978|992|993|994|995|996|998|93|94|95|98|20|27|30|31|32|33|34|36|39|40|41|43|44|45|46|47|48|49|51|52|53|54|55|56|57|58|60|61|62|63|64|65|66|81|82|84|86|90|91|92|7|1)/;

// Phone number length by country code (comprehensive list)
const PHONE_LENGTH_BY_COUNTRY: { [key: string]: number } = {
  '1': 10,
  '7': 10,
  '20': 10,
  '27': 9,
  '30': 10,
  '31': 9,
  '32': 9,
  '33': 9,
  '34': 9,
  '36': 9,
  '39': 10,
  '40': 10,
  '41': 9,
  '43': 10,
  '44': 10,
  '45': 8,
  '46': 9,
  '47': 8,
  '48': 9,
  '49': 11,
  '51': 9,
  '52': 10,
  '53': 8,
  '54': 10,
  '55': 11,
  '56': 9,
  '57': 10,
  '58': 10,
  '60': 9,
  '61': 9,
  '62': 11,
  '63': 10,
  '64': 9,
  '65': 8,
  '66': 9,
  '81': 10,
  '82': 10,
  '84': 9,
  '86': 11,
  '90': 10,
  '91': 10,
  '92': 10,
  '93': 9,
  '94': 9,
  '95': 9,
  '98': 10,
  '212': 9,
  '213': 9,
  '216': 8,
  '218': 10,
  '220': 7,
  '221': 9,
  '222': 8,
  '223': 8,
  '224': 9,
  '225': 10,
  '226': 8,
  '227': 8,
  '228': 8,
  '229': 8,
  '230': 8,
  '231': 8,
  '232': 8,
  '233': 9,
  '234': 10,
  '235': 8,
  '236': 8,
  '237': 9,
  '238': 7,
  '239': 7,
  '240': 9,
  '241': 7,
  '242': 9,
  '243': 9,
  '244': 9,
  '245': 7,
  '246': 7,
  '248': 7,
  '249': 9,
  '250': 9,
  '251': 9,
  '252': 8,
  '253': 8,
  '254': 10,
  '255': 9,
  '256': 9,
  '257': 8,
  '258': 9,
  '260': 9,
  '261': 9,
  '262': 9,
  '263': 9,
  '264': 9,
  '265': 9,
  '266': 8,
  '267': 8,
  '268': 8,
  '269': 7,
  '290': 4,
  '291': 7,
  '297': 7,
  '298': 6,
  '299': 6,
  '350': 8,
  '351': 9,
  '352': 9,
  '353': 9,
  '354': 7,
  '355': 9,
  '356': 8,
  '357': 8,
  '358': 10,
  '359': 9,
  '370': 8,
  '371': 8,
  '372': 8,
  '373': 8,
  '374': 8,
  '375': 9,
  '376': 6,
  '377': 8,
  '378': 10,
  '380': 9,
  '381': 9,
  '382': 8,
  '383': 8,
  '385': 9,
  '386': 8,
  '387': 8,
  '389': 8,
  '420': 9,
  '421': 9,
  '423': 7,
  '500': 5,
  '501': 7,
  '502': 8,
  '503': 8,
  '504': 8,
  '505': 8,
  '506': 8,
  '507': 8,
  '508': 6,
  '509': 8,
  '590': 9,
  '591': 8,
  '592': 7,
  '593': 9,
  '594': 9,
  '595': 9,
  '596': 9,
  '597': 7,
  '598': 8,
  '599': 7,
  '670': 8,
  '672': 6,
  '673': 7,
  '674': 7,
  '675': 8,
  '676': 5,
  '677': 7,
  '678': 7,
  '679': 7,
  '680': 7,
  '681': 6,
  '682': 5,
  '683': 4,
  '684': 7,
  '685': 7,
  '686': 5,
  '687': 6,
  '688': 6,
  '689': 8,
  '690': 4,
  '691': 7,
  '692': 7,
  '850': 10,
  '852': 8,
  '853': 8,
  '855': 9,
  '856': 10,
  '880': 10,
  '886': 9,
  '960': 7,
  '961': 8,
  '962': 9,
  '963': 9,
  '964': 10,
  '965': 8,
  '966': 9,
  '967': 9,
  '968': 8,
  '970': 9,
  '971': 9,
  '972': 9,
  '973': 8,
  '974': 8,
  '975': 8,
  '976': 8,
  '977': 10,
  '992': 9,
  '993': 8,
  '994': 9,
  '995': 9,
  '996': 9,
  '998': 9,
};

export const parsePhoneNumber = (phoneNumber: string) => {
  if (!phoneNumber) {
    throw new Error('Enter valid Country Code');
  }
  if (!phoneNumber.startsWith('+')) {
    return {
      countryCode: '+',
      phoneNumber: phoneNumber,
      fullNumber: phoneNumber,
    };
  }

  const countryCodeMatch = phoneNumber.match(COUNTRY_CODE_REGEX);

  if (!countryCodeMatch) {
    return {
      countryCode: '+91',
      phoneNumber: phoneNumber.substring(1),
      fullNumber: phoneNumber,
    };
  }

  const countryCode = `+${countryCodeMatch[1]}`;
  const phoneOnly = phoneNumber.substring(countryCode.length);

  return {
    countryCode,
    phoneNumber: phoneOnly,
    fullNumber: phoneNumber,
  };
};

export const validatePhoneNumber = (
  phoneNumber: string,
  countryCode: string,
): { isValid: boolean; message?: string } => {
  const code = countryCode.replace('+', '');
  const expectedLength = PHONE_LENGTH_BY_COUNTRY[code] || 10;

  if (!phoneNumber) return { isValid: false, message: 'Mobile number cannot be empty' };
  if (!/^\d+$/.test(phoneNumber)) {
    return { isValid: false, message: 'Phone number must contain only digits' };
  }

  if (phoneNumber.length !== expectedLength) {
    return {
      isValid: false,
      message: `Phone number must be ${expectedLength} digits for ${countryCode}`,
    };
  }

  return { isValid: true };
};
